import React, { Component } from 'react';
import { Rect, Text, Group } from 'react-konva';

export class NotesComponentCanvas extends Component {
    render() {
        const { geometry, component, isSelected, dimentionsRatio, draggable } = this.props;

        const geometryWidth = geometry.width * dimentionsRatio;
        const geometryHeight = geometry.height * dimentionsRatio;

        let componentText;
        if(0 === component.id) {
            componentText = `${component.text} (Novo)`;
        }
        else {
            componentText = `${component.text} (${component.id})`;
        }

        const fontSizeComponentSizeRatio = componentText.length / 1.65;

        let fontSize = geometryHeight / 2.75;
        let textPosX = geometry.drawPositionX + 10 * dimentionsRatio;
        let textPoxY = geometry.drawPositionY + geometryHeight - 10 * dimentionsRatio;
        let textRotation = 0;

        if (geometryWidth >= geometryHeight) {
            if (fontSizeComponentSizeRatio * fontSize > geometryWidth) {
                fontSize = geometryWidth / fontSizeComponentSizeRatio;
            }

            if (fontSize > geometryHeight) {
                fontSize *= geometryHeight / fontSize;
            }
            
            textPoxY = geometry.drawPositionY + geometryHeight / 2.0 - fontSize / 2.5;
        }
        else {
            fontSize = geometryWidth / 2.5;
            textRotation = -90;

            if (fontSizeComponentSizeRatio * fontSize > geometryHeight) {
                fontSize = geometryHeight / fontSizeComponentSizeRatio;
            }

            if (fontSize > geometryWidth) {
                fontSize *= geometryWidth / fontSize;
            }

            textPosX = geometry.drawPositionX + geometryWidth / 2.0 - fontSize / 2.5;
        }        

        return (
            <Group
                offsetX={geometry.offsetX}
                offsetY={geometry.offsetY}
                draggable={draggable}
                onDragEnd={this.props.onDragEnd}
                onClick={this.props.onComponentClick ? () => this.props.onComponentClick(component.internalId) : null} >
                <Rect x={geometry.drawPositionX}
                    y={geometry.drawPositionY}
                    width={geometry.width * dimentionsRatio}
                    height={geometry.height * dimentionsRatio}
                    strokeWidth={isSelected ? 3 : 1}
                    stroke={isSelected ? "#6699ff" : "black"}
                    fill={component.color} />
                <Text text={componentText}
                    fontSize={fontSize}
                    rotation={textRotation}
                    x={textPosX}
                    y={textPoxY} />
            </Group>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/bussched/layoutConfigurations/componentCanvas/NotesComponentCanvas.js